<div id="panel_assessments" class="collapse show" role="tabpanel" aria-labelledby="heading_assessments">
  <div class="card-body table-container">
    <table class="table">
      <tr class="table__row">
        <th class="table__header">Assessment Slug</th>
        <th class="table__header">Passed</th>
        <th class="table__header"></th>
      </tr>
      {{#each assessments}}
        <tr class="table__row">
          <td class="table__cell">{{slug}}</td>
          <td class="table__cell">{{passed}}</td>
          <td class="table__cell">
            {{#if progress}}
              <button class="btn btn-primary btn-compact btn-assess bg-color-error-base" data-slug="{{slug}}" data-module="{{moduleKey}}">Remove</button>
            {{else}}
              <button class="btn btn-primary btn-compact btn-assess btn-success" data-slug="{{slug}}" data-module="{{moduleKey}}" data-pass="true">Pass</button>
              <button class="btn btn-primary btn-compact btn-assess btn-success" data-slug="{{slug}}" data-module="{{moduleKey}}">Fail</button>
            {{/if}}
          </td>
        </tr>
      {{/each}}
    </table>
  </div>
</div>
